/**
 * Opens the horizontal collection filter bar's dropdown panels on hover
 * instead of requiring a click, for desktop mouse users only.
 *
 * Scoped to `.facets__panel[data-auto-close-details]` - list-filter.liquid
 * only sets that attribute when filter_style is 'horizontal', so this never
 * touches the mobile drawer or vertical filter layouts. Click and keyboard
 * (Enter/Space on the summary) keep working via the native <details>
 * behavior; this only adds mouseenter/mouseleave on top of it. Outside-click
 * closing is already handled separately by auto-close-details.js.
 */

const DESKTOP_HOVER_QUERY = '(min-width: 750px) and (hover: hover) and (pointer: fine)';
const CLOSE_DELAY_MS = 150;

for (const panel of document.querySelectorAll('.facets__panel[data-auto-close-details]')) {
  /** @type {ReturnType<typeof setTimeout>|undefined} */
  let closeTimeout;

  panel.addEventListener('mouseenter', () => {
    if (!window.matchMedia(DESKTOP_HOVER_QUERY).matches) return;
    clearTimeout(closeTimeout);
    if (panel instanceof HTMLDetailsElement) panel.open = true;
  });

  panel.addEventListener('mouseleave', () => {
    if (!window.matchMedia(DESKTOP_HOVER_QUERY).matches) return;
    closeTimeout = setTimeout(() => {
      if (panel instanceof HTMLDetailsElement) panel.open = false;
    }, CLOSE_DELAY_MS);
  });
}
